<template>
  <c-modal title='User Data' v-model='open'>
      <c-form @submit.prevent="onSave" layout="horizontal">
        <c-form-field label="User login / email" help="Used for logging in. Mandatory.">
          <c-form-input data-vv-as="User email" v-model="user.login" v-validate="'required|email'" data-vv-name="email"
                        :status="validationStatus('email')" maxlength="50" :readonly="user.id !== null"></c-form-input>
        </c-form-field>
        <c-form-field label="Name" help="User's name. Mandatory.">
          <c-form-input data-vv-as="User name" v-model="user.name" v-validate="'required'" data-vv-name="name"
                        :status="validationStatus('name')" maxlength="100"></c-form-input>
        </c-form-field>
        <c-form-field label="Enabled">
          <c-form-checkbox label="Enabled" v-model="user.enabled"/>
        </c-form-field>
        <c-form-field label="Role" help="Administrators can modify the settings of the application">
          <c-form-radio label="Application Administrator" name="role" v-model="user.role" value="client-admin"/>
          <c-form-radio label="Regular User" name="role" v-model="user.role" value="client"/>
        </c-form-field>
        <c-form-field>
          <c-button @click.prevent="onSave" smart type="primary">Save changes</c-button>
          <c-button @click.prevent="onClose" smart >Close</c-button>
        </c-form-field>
      </c-form>
  </c-modal>
</template>

<script>
import {mapState} from 'vuex'
import usersAdmin from '../../services/usersadmin.service'

export default {
  name: 'ClientUser',

  computed: {
    ...mapState('auth', ['clientCode', 'clientId'])
  },

  data () {
    return {
      open: false,
      user: {
        id: null
      }
    }
  },
  methods: {
    newUser () {
      this.user = {
        'id': null,
        'name': null,
        'login': null,
        'enabled': true
      }
      this.open = true
    },

    editUser (userId) {
      usersAdmin.getUserData(this.clientCode, userId).then((response) => {
        this.handleData(response.data)
      }).catch((reason) => {
        console.error('Could not get data')
        console.error(reason)
      })
    },

    validationStatus (field) {
      if (this.errors.has(field)) {
        return 'danger'
      } else {
        return ''
      }
    },

    handleData (user) {
      this.user = user
      this.open = true
    },

    onClose (user) {
      this.open = false
    },

    onSave () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          if (this.user.id === null) {
            usersAdmin.createUser(this.clientCode, this.user).then((response) => {
              this.user = response.data
              this.$snotify.success('Changes saved successfully', null, {
                position: 'centerTop',
                timeout: 3000,
                showProgressBar: false
              })
            })
              .catch(reason => {
                let message = 'Could not create user'
                if ('code' in reason.response.data && 'reason' in reason.response.data) {
                  message = reason.response.data.reason
                }
                this.$snotify.error(message, null, {
                  position: 'centerTop',
                  timeout: 3000,
                  showProgressBar: false
                })
              })
          } else {
            usersAdmin.updateUser(this.clientCode, this.user.id, this.user).then((response) => {
              this.$snotify.success('Changes saved successfully', null, {
                position: 'centerTop',
                timeout: 3000,
                showProgressBar: false
              })
            })
              .catch(reason => {
                this.$snotify.error('Could not update user data', null, {
                  position: 'centerTop',
                  timeout: 3000,
                  showProgressBar: false
                })
              })
          }
        }
      })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ClientSettings/User.vue